module.exports = __webpack_public_path__ + "img/header_logo.f8216473.png";